import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FocusInputType, KeyValues3, LocalService } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';

@Component({
  selector: 'app-local-locations',
  templateUrl: './local-locations.component.html',
  styleUrls: ['./local-locations.component.scss']
})
export class LocalLocationsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["local_locations"];
  @Input() CtryCode = '';
  @Input() Id = '';
  @Input() locations: KeyValues3;
  @Input() CountryId = '';
  lastCountryId = null;
  @Input() isSetFromLogin = false;
  isSetFromSource = false;
  @Output() locationsChange = new EventEmitter<any>();
  @Output() onLocationUpdated = new EventEmitter();

  states: any; districts: any; constituencies: any;
  elementIds: any;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private locationManagementService: LocationManagementService) { }

  ngOnInit(): void {
    this.elementIds = {
      state: 'local_location_state_' + this.Id,
      district: 'local_location_district_' + this.Id,
      constituency: 'local_location_constituency_' + this.Id
    };
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    this.onLoad();
  }

  onLoad() {
    if (this.CtryCode == '')
      this.CtryCode = this.localService.selected.countryCode;
    if (this.CountryId == '' && this.localService.loggedMember)
      this.CountryId = this.localService.loggedMember.loggedMember.content.v2;
    if (this.CountryId != '' && this.CountryId != this.lastCountryId) {
      this.onLoadEmptyContainer(this.lastCountryId);
      this.lastCountryId = this.CountryId;
    }
  }

  onLanguageChanged() {
    this.lastCountryId = '';
    this.onLoad();
  }

  onLoadEmptyContainer(isResetAll = false) {
    if (this.CountryId != '') {
      if (!this.locations || this.locations.v3 == '') {
        if (isResetAll)
          this.locations = { v3: '', v2: '', v1: '' } as KeyValues3;
        this.locationManagementService.getChildLocations(this.CountryId, this.CtryCode).subscribe(result => {
          this.districts = null;
          this.constituencies = null;
          this.states = result.contents;
          if (isResetAll) {
            this.locations.v3 = this.localService.loggedMember ? this.localService.loggedMember.loggedMember.localLocations.v3 : '';
            this.locations.v2 = '';
            this.locations.v1 = '';
          }
          if (this.locations.v3 == '' && this.isSetFromLogin) {
            this.locations.v3 = this.localService.loggedMember ? this.localService.loggedMember.loggedMember.localLocations.v3 : '';
          }
          if (this.locations.v3 != '') {
            this.onLocationUpdated.emit(this.locations);
            this.isSetFromLogin = true;
            this.onLocationChanged(1);
          }
        });
      } else {
        this.locationManagementService.getChildLocations(this.CountryId, this.CtryCode).subscribe(result => {
          if (isResetAll) {
            this.locations.v3 = '';
            this.locations.v2 = '';
            this.locations.v1 = '';
          }
          this.districts = null;
          this.constituencies = null;
          this.states = result.contents;
          this.isSetFromSource = true;
          this.onLocationChanged(1);
        });
      }
    }
  }

  onLocationChanged(index) {
    let locationId = index == 1 ? this.locations.v3 : index == 2 ? this.locations.v2 : '';
    if (locationId && locationId != '') {
      this.locationManagementService.getChildLocations(locationId, this.CtryCode).subscribe(result => {
        switch (index) {
          case 1: {
            this.districts = result.contents;
            this.locations.v2 = this.isSetFromLogin ? (this.localService.loggedMember ? this.localService.loggedMember.loggedMember.localLocations.v2 : '') : (this.isSetFromSource ? this.locations.v2 : '');
            if (!this.isSetFromSource)
              this.locations.v1 = '';
            this.constituencies = null;
            this.onLocationUpdated.emit(this.locations);
            if (this.locations.v2 != '' && (this.isSetFromLogin || this.isSetFromSource))
              this.onLocationChanged(2);
            if (!(this.isSetFromLogin || this.isSetFromSource))
              this.localService.onFocusNextInput(this.elementIds.district, FocusInputType.NgxDropDown);
          } break;
          case 2: {
            this.constituencies = result.contents;
            this.locations.v1 = this.isSetFromLogin ? (this.localService.loggedMember ? this.localService.loggedMember.loggedMember.localLocations.v1 : '') : (this.isSetFromSource ? this.locations.v1 : '');
            if (!(this.isSetFromLogin || this.isSetFromSource))
              this.localService.onFocusNextInput(this.elementIds.constituency, FocusInputType.NgxDropDown);
            this.isSetFromLogin = false;
            this.isSetFromSource = false;
            this.onLocationUpdated.emit(this.locations);
          } break;
        }
      });
    } else
      this.onLocationUpdated.emit(this.locations);
  }
}
